import {
	Box,
	Button,
	IconButton,
	LinearProgress,
	Stack,
	Typography,
	Grid,
} from '@mui/material'

import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateProfile } from '../../../features/authSlice'
import { getVendorReviews } from '../../../features/reviewSlice'
import styles from './index.module.scss'
const ratingData = [
	{ rating: 5, percent: 55 },
	{ rating: 4, percent: 20 },
	{ rating: 3, percent: 10 },
	{ rating: 2, percent: 10 },
	{ rating: 1, percent: 5 },
]
const reviewerFb = [
	{
		img: '/images/reviewr-img.svg',
		name: 'Brooklyn Simmons',
		feedback:
			'Amet minim mollit non deserunt mo est sit aliqua dolor do amet sint. Velit officia enim velit mollit.',
		publicAt: 'Published 5 weeks ago',
	},
	{
		img: '/images/reviewr-img.svg',
		name: 'Brooklyn Simmons',
		feedback:
			'Amet minim mollit non deserunt mo est sit aliqua dolor do amet sint. Velit officia enim velit mollit.',
		publicAt: 'Published 5 weeks ago',
	},
	{
		img: '/images/reviewr-img.svg',
		name: 'Brooklyn Simmons',
		feedback:
			'Amet minim mollit non deserunt mo est sit aliqua dolor do amet sint. Velit officia enim velit mollit.',
		publicAt: 'Published 5 weeks ago',
	},
	{
		img: '/images/reviewr-img.svg',
		name: 'Brooklyn Simmons',
		feedback:
			'Amet minim mollit non deserunt mo est sit aliqua dolor do amet sint. Velit officia enim velit mollit.',
		publicAt: 'Published 5 weeks ago',
	},
	{
		img: '/images/reviewr-img.svg',
		name: 'Brooklyn Simmons',
		feedback:
			'Amet minim mollit non deserunt mo est sit aliqua dolor do amet sint. Velit officia enim velit mollit.',
		publicAt: 'Published 5 weeks ago',
	},
	{
		img: '/images/reviewr-img.svg',
		name: 'Brooklyn Simmons',
		feedback:
			'Amet minim mollit non deserunt mo est sit aliqua dolor do amet sint. Velit officia enim velit mollit.',
		publicAt: 'Published 5 weeks ago',
	},
]

export const RatingReviewCard = ({ formData, cardStyle, editable, vendorId, reviewsData }) => {
	const dispatch = useDispatch()
	const [editing, setEditing] = useState(false)
	const [reviews, setReviews] = useState([])
	const [stats, setStats] = useState(null)

	// Fetch vendor reviews on component mount or when vendorId changes
	useEffect(() => {
		if (vendorId && !reviewsData) {
			dispatch(getVendorReviews({ vendorId, page: 1, limit: 6 }))
				.then((result) => {
					if (result.payload?.success) {
						setReviews(result.payload.reviews || [])
						setStats(result.payload.stats || null)
					}
				})
				.catch((err) => console.error('Error fetching reviews:', err))
		} else if (reviewsData) {
			setReviews(reviewsData.reviews || [])
			setStats(reviewsData.stats || null)
		}
	}, [vendorId, reviewsData, dispatch])

	// Build rating distribution data from stats
	const ratingData = stats
		? [
				{
					rating: 5,
					percent:
						stats.totalReviews > 0
							? Math.round(
									(stats.distribution[5] / stats.totalReviews) *
										100
								)
							: 0,
				},
				{
					rating: 4,
					percent:
						stats.totalReviews > 0
							? Math.round(
									(stats.distribution[4] / stats.totalReviews) *
										100
								)
							: 0,
				},
				{
					rating: 3,
					percent:
						stats.totalReviews > 0
							? Math.round(
									(stats.distribution[3] / stats.totalReviews) *
										100
								)
							: 0,
				},
				{
					rating: 2,
					percent:
						stats.totalReviews > 0
							? Math.round(
									(stats.distribution[2] / stats.totalReviews) *
										100
								)
							: 0,
				},
				{
					rating: 1,
					percent:
						stats.totalReviews > 0
							? Math.round(
									(stats.distribution[1] / stats.totalReviews) *
										100
								)
							: 0,
				},
			]
		: [
				{ rating: 5, percent: 0 },
				{ rating: 4, percent: 0 },
				{ rating: 3, percent: 0 },
				{ rating: 2, percent: 0 },
				{ rating: 1, percent: 0 },
			]

	const handleSave = () => {
		dispatch(
			updateProfile({
				instagramLink: formData.instagramLink,
				tiktokLink: formData.tiktokLink,
				facebookLink: formData.facebookLink,
                websiteLink: formData.websiteLink,
			})
		)
		setEditing(false)
	}

	return (
		<div
			sx={cardStyle}
			className={`${styles.cardWrp} ${styles.ratingReviewCard} `}
		>
			<div className={styles.infoHeader}>
				<Typography
					variant="h5"
					gutterBottom
					sx={{ fontWeight: 'bold' }}
				>
					Ratings & Review ({stats?.totalReviews || 0})
				</Typography>
				{editable && (
					<Box>
						<IconButton
							component="label"
							className={styles.editIcon}
							disableRipple
							onClick={() => setEditing(true)}
						>
							<img
								src="/images/edit-icon.svg"
								alt="business pic"
							/>
						</IconButton>
						{editing && <Button onClick={handleSave}>Save</Button>}
					</Box>
				)}
			</div>
			<div className={styles.ratingReviewInner}>
				<Grid container spacing={2}>
					<Grid size={{ xs: 12, sm: 5 }}>
						<div className={styles.left}>
							<div className={styles.ratingNumber}>
								<img
									src="/images/review-leaf.svg"
									alt="review-leaf.svg"
									className={styles.reviewBeforeImg}
								/>
								<Typography
									variant="h3"
									sx={{ fontWeight: 'bold', fontSize: 36 }}
								>
									{stats?.avgRating || 0}
								</Typography>
								<img
									src="/images/review-leaf.svg"
									alt="review-leaf.svg"
									className={styles.reviewAfterImg}
								/>
							</div>
							{/* Progress Bars for Each Rating */}
							{ratingData.map((item) => (
								<Box key={item.rating} sx={{ marginTop: 1 }}>
									<Stack
										direction="row"
										alignItems="center"
										spacing={2}
									>
										<LinearProgress
											variant="determinate"
											value={item.percent}
											sx={{
												flexGrow: 1,
												height: 8,
												borderRadius: 4,
												backgroundColor: '#fff',
												'& .MuiLinearProgress-bar': {
													backgroundColor: '#7CA6BD',
													borderRadius: 4,
												},
											}}
										/>
										<div className={styles.ratingPercent}>
											<Typography variant="h5">
												{item.rating}
											</Typography>
											<img
												src="/images/star.svg"
												alt="star.svg"
											/>
											<Typography variant="h6">
												({item.percent}%)
											</Typography>
										</div>
									</Stack>
								</Box>
							))}
						</div>
					</Grid>
					<Grid size={{ xs: 12, sm: 7 }}>
						<div className={styles.reviewContentWrp}>
							{reviews && reviews.length > 0 ? (
								reviews.map((review, index) => {
									const starArray = Array(5)
										.fill(0)
										.map((_, i) => i < review.rating)
									return (
										<div
											className={styles.reviewContent}
											key={index}
										>
											<div className={styles.reviewerImg}>
												<img
													src={
														review.userId?.profilePic ||
														'/images/reviewr-img.svg'
													}
													alt={review.userId?.firstName}
												/>
											</div>
											<div className={styles.reviewerContent}>
												<Typography variant="h4">
													{`${review.userId?.firstName || 'User'} ${review.userId?.lastName || ''}`}
												</Typography>
												<ul className={styles.reviewStar}>
													{starArray.map((isFilled, i) => (
														<li key={i}>
															<img
																src={
																	isFilled
																		? '/images/star.svg'
																		: '/images/star-without-fill.svg'
																}
																alt="star"
															/>
														</li>
													))}
												</ul>
												<Typography variant="h5">
													{review.comment}
												</Typography>
												<Typography variant="h6">
													Published{' '}
													{new Date(
														review.createdAt
													).toLocaleDateString('en-US', {
														year: 'numeric',
														month: 'short',
														day: 'numeric',
													})}
												</Typography>
											</div>
										</div>
									)
								})
							) : (
								<Typography variant="h6" sx={{ textAlign: 'center', py: 3 }}>
									No reviews yet
								</Typography>
							)}
						</div>
					</Grid>
				</Grid>
			</div>
		</div>
	)
}
